import { FC } from 'react';
import { FormFieldControlProps } from '@app/form_components';
import { ValueOrVariableAutocomplete } from '@app/page-components/shared';
import {
  FormControlProps,
  ModuleInput,
  ValueOrVariable,
  ValueOrVariableType,
  ValueTypeForVariableType,
  VariableType,
  VariableValue
} from '@app/types';
import { VariableOption } from '@app/utilities';

type ModuleInputFormProps = (
  FormControlProps<ModuleInput>
  & FormFieldControlProps
  & {
    value: ModuleInput;
    valueType: VariableType | undefined;
  }
);

export const ModuleInputForm: FC<ModuleInputFormProps> = ({
  onChange,
  value,
  ...variableAutocompleteProps
}) => {
  const handleChange = (
    newValue: ValueOrVariable<VariableValue>,
    option: VariableOption | null
  ) => {
    const base = {
      argumentName: value.argumentName,
      id: value.id
    };
    if (newValue.type === ValueOrVariableType.value) {
      onChange({ ...newValue, ...base });
    } else {
      onChange({
        ...newValue,
        defaultValue: option?.defaultValue ?? null,
        sensitiveData: option?.sensitiveData ?? false,
        ...base
      });
    }
  };

  return (
    <ValueOrVariableAutocomplete
      {...variableAutocompleteProps}
      onChange={handleChange}
      value={value as ModuleInput<ValueTypeForVariableType<VariableType>>}
    />
  );
};
